/** @format */

import POSHome from "../Pages/POS";
import AddCustomers from "../Pages/Customers";
import OrderInvoice from "../Pages/Orders/Invoice";
import OrdersHistory from "../Pages/Orders/History";
import Registers from "../Pages/Registers";
import Discounts from "../Pages/Discounts";
import ActivitiesPage from "../Pages/Activities";
import PaymentTypes from "../Pages/PaymentTypes";
import CustomersList from "../Pages/Customers/CustomersList";
import CashierList from "../Pages/Cashier/CashierList";
import PageBuilder from "../Pages/CMS";
import RegisterSummary from "../Pages/Registers/RegisterSummary";
import SnapEBTSuccess from "../Pages/POS/SnapEBTSuccess";
import PrivateChatContainer from "../Components/Applications/Chat/PrivateChat";
import Settings from "../Pages/Settings";
import ChatPopup from "../Pages/Applications/Chat/PrivateChat";
import CloseReports from "../Pages/Reports/CloseReport";
import ReportsHome from "../Pages/Reports";
import EndDayReports from "../Pages/Reports/EOD";
import CloseReportDetails from "../Pages/Reports/CloseDetailReport";
import TransactionReports from "../Pages/Reports/TransactionReports";
import SalesReportByUser from "../Pages/Reports/SalesReportByUser";
import SalesReportByItems from "../Pages/Reports/SalesReportByItems";
import SalesReportByCategory from "../Pages/Reports/SalesReportByCategories";
import SalesTaxReport from "../Pages/Reports/SalesTaxReport";
import SalesReportByPlatform from "../Pages/Reports/SalesReportByPlatform";
import EndDay from "../Pages/EndDay";
import ProductListContainer from "../Pages/Products";
import AddProduct from "../Pages/Products/AddProduct";
import StockReport from "../Pages/Reports/StockReport";
import StockZeroReport from "../Pages/Reports/StockZeroReport";
import ProductAddons from "../Pages/Products/Addons";
import path from "path";
import AddCashier from "../Pages/Cashier";
import ProductCategories from "../Pages/Categories";
import EODSummary from "../Pages/Reports/EOD/EODSummary";
import EODByCategory from "../Pages/Reports/EOD/EODByCategory";
import EODByPayTypes from "../Pages/Reports/EOD/EODByPayTypes";
import PrintersPage from "../Pages/Printers";
import PaymentType from "../Pages/MyStore/PaymentType";
import SalesHistory from "../Pages/MyStore/SalesHistory";
import SalesTrends from "../Pages/MyStore/SalesTrends";
import SalesByDepartment from "../Pages/MyStore/SalesByDepartment";
import SalesByVendor from "../Pages/MyStore/SalesByVendor";
import TransactionType from "../Pages/MyStore/TransactionType";
import EventDiscountsPage from "../Pages/EventDiscounts";
import VideoGenerator from "../Pages/VideoGenerator";
import VideosList from "../Pages/VideosList";
import Stories from "../Pages/Stories";
import ScenesList from "../Pages/ScenesList";

export const routes = [
  {
    path: `${process.env.PUBLIC_URL}/dashboard`,
    element: <POSHome />,
  },
  {
    path: `${process.env.PUBLIC_URL}/orders`,
    element: <OrdersHistory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/registers`,
    element: <Registers />,
  },
  {
    path: `${process.env.PUBLIC_URL}/end-day`,
    element: <EndDay />,
  },
  {
    path: `${process.env.PUBLIC_URL}/products`,
    element: <ProductListContainer />,
  },
  {
    path: `${process.env.PUBLIC_URL}/addons`,
    element: <ProductAddons />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/products/new`,
  //   element: <AddProduct />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/products/:product_id`,
  //   element: <AddProduct />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/snap-ebt-success`,
    element: <SnapEBTSuccess />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/registers/summary/:register_id`,
  //   element: <RegisterSummary />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/discounts`,
    element: <Discounts />,
  },
  {
    path: `${process.env.PUBLIC_URL}/event-discounts`,
    element: <EventDiscountsPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/customers`,
    element: <CustomersList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/cashiers`,
    element: <CashierList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/videos`,
    element: <VideoGenerator />,
  },
  {
    path: `${process.env.PUBLIC_URL}/videos-list`,
    element: <VideosList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/scenes`,
    element: <ScenesList />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/cashiers/new`,
  //   element: <AddCashier />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/cashiers/:cashier_id`,
  //   element: <AddCashier />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/customers/new`,
  //   element: <AddCustomers />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/customers/:customer_id`,
  //   element: <AddCustomers />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/pos`,
    element: <POSHome />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pos/:order_id`,
    element: <POSHome />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/invoice/:order_id`,
  //   element: <OrderInvoice />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/activities`,
    element: <ActivitiesPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payment-types`,
    element: <PaymentTypes />,
  },
  {
    path: `${process.env.PUBLIC_URL}/builder`,
    element: <PageBuilder />,
  },
  {
    path: `${process.env.PUBLIC_URL}/chat`,
    element: <PrivateChatContainer />,
  },
  {
    path: `${process.env.PUBLIC_URL}/chat-popup`,
    element: <ChatPopup />,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings`,
    element: <Settings />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports`,
    element: <ReportsHome />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/close`,
    element: <CloseReports />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/reports/close/:register_id`,
  //   element: <CloseReportDetails />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/reports/end-day`,
    element: <EndDayReports />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/reports/eod/summary/:register_id`,
  //   element: <EODSummary />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/reports/eod/category/:register_id`,
  //   element: <EODByCategory />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/reports/eod/paytypes/:register_id`,
  //   element: <EODByPayTypes />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/reports/transactions`,
    element: <TransactionReports />,
  },
  {
    path: `${process.env.PUBLIC_URL}/categories`,
    element: <ProductCategories />,
  },
  {
    path: `${process.env.PUBLIC_URL}/printers`,
    element: <PrintersPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-store/payment-types`,
    element: <PaymentType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-store/sales-history`,
    element: <SalesHistory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-store/sales-trends`,
    element: <SalesTrends />,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-store/sales-by-department`,
    element: <SalesByDepartment />,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-store/sales-by-vendor`,
    element: <SalesByVendor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-store/transaction-type`,
    element: <TransactionType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/stories`,
    element: <Stories />,
  },
];
